import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  Grid,
  Card,
  CardContent,
  Typography,
  Chip,
  IconButton,
  Button,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";


const MeetingReportPopup = ({ open, setOpen, reportData, handleResendEmail }) => {
  return (
    <Dialog open={open} fullWidth maxWidth="md">
      <DialogTitle sx={{ display: "flex", justifyContent: "space-between" }}>
        Meeting Email Reports
        <IconButton onClick={() => setOpen(false)}>
          <CloseIcon />
        </IconButton>
      </DialogTitle>

      <DialogContent dividers>
        <Grid container spacing={2}>
          {reportData?.map((item) => (
            <Grid item xs={12} md={6} key={item.id}>
              <Card sx={{ borderRadius: 3, boxShadow: 3 }}>
                <CardContent>
                  <Typography variant="h6" fontWeight={600}>
                    {item.student_name}
                  </Typography>

                  <Typography>Email: {item.email}</Typography>

                  <Typography sx={{ mt: 1 }}>
                    Created: {item.created_at}
                  </Typography>

                  <Chip
                    label={item.status.toUpperCase()}
                    color={
                      item.status === "sent"
                        ? "success"
                        : item.status === "failed"
                        ? "error"
                        : "warning"
                    }
                    sx={{ mt: 2 }}
                  />
                  <Button
                    variant="contained"
                    size="small"
                    sx={{ mt: 2, borderRadius: 2,ml:2 }}
                    onClick={() => handleResendEmail(item)}
                  >
                    Resend Email
                  </Button>
                </CardContent>
              </Card>
            </Grid>
          ))}
        </Grid>
      </DialogContent>
    </Dialog>
  );
};

export default MeetingReportPopup;
